import { render } from "./StatPlacement.vue?vue&type=template&id=c4b82716&scoped=true&ts=true"
import script from "./StatPlacement.vue?vue&type=script&lang=ts"
export * from "./StatPlacement.vue?vue&type=script&lang=ts"

import "./StatPlacement.vue?vue&type=style&index=0&id=c4b82716&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b82716"]])

export default __exports__